import { render, staticRenderFns } from "./kingdomz.vue?vue&type=template&id=6bf7748a"
import script from "./kingdomz.vue?vue&type=script&lang=js"
export * from "./kingdomz.vue?vue&type=script&lang=js"
import style0 from "./kingdomz.vue?vue&type=style&index=0&id=6bf7748a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports